const debounce = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
        }, wait);
    };
}

['click', 'focus'].forEach((eventType) => {
  window.addEventListener(eventType, (e) => {
    if (!e.target.closest('[data-accessibility-trigger]')) return;
    
    document.getElementById('userwayAccessibilityIcon')?.click();
  })  
});

const countrySuffixlist = [{'CA': "canada"}]
const getSuffix = () => {
  const country = Shopify.country;
  if (countrySuffixlist.some(item => Object.keys(item).includes(country))) {
    const baseSuffix = countrySuffixlist.find(item => item[country])[country];
    return `_${baseSuffix}_${Shopify.locale}`;
  }
  return ""
}

const currentTime = new Date();

// document.querySelectorAll('[data-judgeme-review]').forEach(judgeme_review => {
//   const badge_text = judgeme_review.querySelector('.jdgm-prev-badge__text');
//   if (!badge_text) return;
  
//   const formatted_number = Number(badge_text.innerHTML.replace(/[^\d]/g, '')).toLocaleString();
//   const stars = judgeme_review.querySelector('.jdgm-prev-badge__stars');
  
//   badge_text.innerHTML = `(${formatted_number})`;

//   badge_text.style.cssText = "font-size: 12px; display:flex; align-items:center;";
//   stars.style.cssText = "line-height: 1rem;";
//   const spanElement = document.createElement('span');

//   spanElement.textContent = 'Read Reviews'; 
//   spanElement.style.cssText = "position:absolute; right: 0; bottom:-18px; font-size: 12px; text-decoration: underline;";

//   badge_text.insertAdjacentElement('afterend', spanElement);

// });



//Gorgias vs Klaviyo on mobile
const mediaQuery = window.matchMedia("(max-width: 768px)");
const observeMediaQuery = ((ev) => {
  const zIndexUpdates = ((el, update_gorgias = false, is_klaviyo = false) => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target !== el) return;

        let submenu_open = false;
        let search_open = false;
        const submenu_buttons = document.querySelectorAll('[data-action="open-submenu"]');
        const search = document.querySelector('predictive-search');

        submenu_buttons.forEach(button => {
          if (button.classList.contains('active')) submenu_open = true;
        });

        if (search.classList.contains('active')) search_open = true;

        if (submenu_open || search_open) return;

        const gorgias_container = document.querySelector('#gorgias-chat-container');
        const klaviyo_close_form = document.querySelector('.klaviyo-close-form');
        if (klaviyo_close_form) klaviyo_close_form.style.cssText += 'z-index: 1000 !important';

        if (is_klaviyo) return;

        if (update_gorgias && gorgias_container) gorgias_container.style.zIndex = entry.isIntersecting ? '-1' : '31';

        // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
        //   needsclick_el.style.zIndex = entry.isIntersecting ? '-1' : '31';
        // });
      });
    }, { root: null, threshold: 0.1 });
  
    observer.observe(el);
  });

  const lookForIntersectingElements = ((selector, callback) => {
    const observer = new MutationObserver((mutations, obs) => {
      const intersecting_el = document.querySelector(selector);
      if (intersecting_el) callback(intersecting_el);
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  });
  
  // Checks for gorgias chat intersection
  lookForIntersectingElements("#chat-window", (el) => {
    zIndexUpdates(el);
  });

  // Checks for klaviyo intersection
  lookForIntersectingElements(".klaviyo-form", (el) => {
    zIndexUpdates(el, false, true);
  });
});

observeMediaQuery(mediaQuery);
mediaQuery.addEventListener('change', observeMediaQuery);

document.addEventListener('click', e => {
  let target = e.target;
  while (target && !target.hasAttribute('data-product-url')) target = target.parentElement;
  target ? sessionStorage.setItem('scrollPosition', window.scrollY) : sessionStorage.removeItem('scrollPosition');
});

const persistOptionsFromWindow = (el) => {
  if (window.selectedOptionsToPersist) {
    window.selectedOptionsToPersist.forEach((option) => {
      const persistedOptionInput = el.querySelector(`input[data-option-type][value="${option}"]`);
      if (persistedOptionInput) {
        const optionType = persistedOptionInput.dataset.optionType;
        const titleEl = el.querySelector(`[data-${optionType.toLowerCase()}-title`);
        titleEl.innerHTML = `: ${option}`
        persistedOptionInput.checked = true;
      }
    })
  };
}

function poll(fn, timeout, interval) {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve, reject) {
    var result = fn();
    if(result) {
      resolve(result);
    }
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    else {
      // reject(new Error('timed out for ' + fn + ': ' + arguments));
      reject();
    }
  };

  return new Promise(checkCondition);
}

document.addEventListener('DOMContentLoaded', () => {
  setHeaderHeight();
});

window.addEventListener('resize', () => {
  setHeaderHeight();
});

setHeaderHeight = () => {
  let headerHeight = 0;

  // Sum non-sticky header elements
  document.querySelectorAll('.shopify-section-group-header-group:not(.announce-sticky)').forEach((el) => {
    headerHeight += el.offsetHeight;
  });

  // Find tallest announce-sticky element
  const announceStickies = document.querySelectorAll('.announce-sticky');
  let tallestAnnounceHeight = 0;
  announceStickies.forEach((el) => {
    tallestAnnounceHeight = Math.max(tallestAnnounceHeight, el.offsetHeight);
  });

  headerHeight += tallestAnnounceHeight;

  // Apply the total header height to CSS custom property
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
}


// document.addEventListener('click', e => {
//   const filter_drawer = e.target.closest('[data-action="open-algolia-filter-drawer"]');

//   if (!filter_drawer) return;

//   document.querySelectorAll('.needsclick').forEach((el) => {
//     el.style.zIndex = '-1';
//   });
// });

// document.addEventListener('click', e => {
//   const close_filter_drawer = e.target.closest('[data-action="close-algolia-filter-drawer"]');

//   if (!close_filter_drawer) return;

//   document.querySelectorAll('.needsclick').forEach((el) => {
//     el.style.zIndex = '1';
//   });
// });


const redirectShown = sessionStorage.getItem('redirect_shown');
if (!redirectShown) {
  getLocation();
}

async function getLocation() {
  const locations = ['US', 'GB', 'EU', 'CA'] // Array of availible locales
  try {
    const response = await fetch('https://api.ipgeolocation.io/ipgeo');
    const result = await response.json();
    const store = Shopify.country;
    const currency = Shopify.currency.active;
    const locationInfo = {
      countryCode: result.is_eu ? 'EU' : result.country_code2,
      contentName: result.is_eu ? 'Europe' : result.country_name,
      //countryCode: 'EU',
      //contentName: 'EUROPE'
    };
    const code = locationInfo.countryCode;
    const countryName = locationInfo.contentName;
    console.log(result)
    console.log(locationInfo, store)
    console.log(currency)
    if (!code) return;
    if (currency == 'EUR' && code == 'EU') return;
    //sessionStorage.setItem('locale', code + ' - ' + countryName); // For testing
    if (!locations.includes(code)) {
      sessionStorage.setItem('redirect_shown', 'true'); // If they are outside of the locations array just disable the poup
    } else if (store != code) {
      redirectUser(code, countryName);
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

function redirectUser(code, countryName) {
  const template = document.querySelector(`[data-drawer-content="redirect"]`); 
  const modal = document.querySelector('custom-modal');
  if (!template) return;  
  const content = template.content?.cloneNode(true) || template.cloneNode(true);
  modal.replaceChildren(content);
  modal.classList.remove('hidden');
  modal.classList.add('center','redirect','transition-all','duration-500');

  modal.querySelector('[data-code]').innerHTML = countryName;

  const lower = code.toLowerCase();

  waitForFakeSelect(modal, lower).then(() => {
    const fake = modal.querySelector('fake-select');
    const root = fake?.shadowRoot;
    const opt = root?.querySelector(`div [data-value="${lower}"]`);
    opt?.click();
  });

  const flag = modal.querySelector('[data-flag]');
  const url = new URL(flag.src);
  url.pathname = url.pathname.replace(/[^/]+\.svg$/, lower + '.svg');
  flag.src = url.toString();
  flag.classList.remove('hidden')
  setTimeout(() => {
    document.body.classList.add('overlay');
    modal.querySelector('[data-drawer-action="close"]')?.focus();
    modal.classList.add('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-20');
  }, 10);
  sessionStorage.setItem('redirect_shown', 'true');
}

function waitForFakeSelect(container, code) {
  return new Promise(resolve => {
    const start = performance.now();
    (function check() {
      const fake = container.querySelector('fake-select');
      const opt = fake?.shadowRoot?.querySelector(`div [data-value="${code}"]`);
      if (opt) return resolve();
      if (performance.now() - start > 2000) return resolve();
      requestAnimationFrame(check);
    })();
  });
}
